module.exports = __webpack_public_path__ + "img/standard-clean5.b2b869de.jpg";